var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8113_28252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 2.1001C9.77436 2.1001 7.94497 2.88789 6.68748 4.37443C5.44734 5.84044 4.8496 7.8832 4.8496 10.2501L4.84961 11.0001C4.84961 13.4652 4.16637 14.9249 3.19325 15.8682C2.81171 16.2381 2.77211 16.7499 2.90849 17.1264C3.04719 17.5094 3.4273 17.9001 3.99916 17.9001H20C20.5719 17.9001 20.952 17.5094 21.0907 17.1264C21.2271 16.7499 21.1875 16.2381 20.8059 15.8682C19.8328 14.9249 19.1496 13.4652 19.1496 11.0001L19.1496 10.2501C19.1496 7.8832 18.5519 5.84044 17.3117 4.37443C16.0542 2.88789 14.2248 2.1001 11.9996 2.1001Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09972 20.1001V21.9001H14.8997V20.1001H9.09972Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8113_28252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1B1C1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.f59ed8993d14ae7f9696a31db303850f.svg";
export { ForwardRef as ReactComponent };